import { makeAutoObservable } from "mobx";

enum routes {
    home = '/',
    game = '/game'
}

class RouterStore {
    pathname = "";
    search = "";
    params: Record<string, string | undefined> = {};

    constructor() {
        makeAutoObservable(this);
    }

    get isHomePage() {
        return this.pathname.length === 1
    }

    get isGamePage() {
        return this.pathname.includes(routes.game)
    }

    update(location: { pathname: string; search: string }, params: Record<string, string | undefined> = {}) {
        this.pathname = location.pathname;
        this.search = location.search;
        this.params = { ...params };

        console.log('PATHNAME: ',this.pathname)
    }

    get query() {
        return Object.fromEntries(new URLSearchParams(this.search));
    }

    getParam(key: string): string | undefined {
        return this.params[key];
    }

    getQueryParam(key: string): string | null {
        return this.query[key] || null;
    }
}

export const routerStore = new RouterStore();